export {};
//# sourceMappingURL=IRequestContext.js.map